<div class="container-fluid">
  <ccc-cca-loading-spinner [show]="isLoading"></ccc-cca-loading-spinner>
  <div>
    <ccc-cca-users-filter (filters)="onFiltersEmitted($event)"></ccc-cca-users-filter>
    <div class="row mt-2 inactive-active-container flex-nowrap" [class.invisible]="!atLeastOneSelected">
      <button class="btn btn-sm btn-primary apply btn-square pointer"
              *ngIf="showMakeActive()"
              (click)="applyAction(false)">
        Make Active
      </button>

      <button class="btn btn-sm btn-primary apply btn-square pointer"
              *ngIf="showMakeInactive()"
              (click)="applyAction(true)">
        Make Inactive
      </button>
    </div>
    <ccc-table *ngIf="!isLoading && accounts?.length !== 0"
               class="table-hover"
               [config]="tableConfig"
               (sortField)="onSort($event)"
               (functionEmitted)="onFunctionEmitted($event)"
               (pageChanged)="onPageChange($event)">
      <tbody>
      <tr *ngFor="let account of accounts">
        <td class="row-checkbox">
          <input type="checkbox" class="custom-selectors" [checked]="selectedAccounts[account.id]"
                 (change)="onCheckAccount(account.id, $event)"/>
        </td>
        <td>
          {{ account.firstName }}
        </td>
        <td>
          {{ account.lastName }}
        </td>
        <td>
          {{ account.email }}
        </td>
        <td>
          {{ account.status }}
        </td>
        <td>
          {{ getRole(account) }}
        </td>
        <td>
          <span
            class="last-login-date"
            *ngIf="account.lastLogin">
            {{ account.lastLogin | date: 'yyyy-MM-dd H:mm' }}
          </span>
          <span
            class="d-inline-block"
            *ngIf="!account.lastLogin">-</span>
        </td>
        <td>
          <div class="actions">
            <button *ngIf="!isSending"
                    class="bg-transparent border-0 p-0"
                    [attr.aria-label]="'Login as ' + account.firstName"
                    (click)="loginAs(account)"
                    [ngbTooltip]="getLoginAsTooltip(account)"
                    triggers="hover"
                    tooltipClass="tooltip-border-right-arrow-right"
                    [disabled]="account.status === 'Inactive'"
                    placement="left">
              <i class="fas fa-lg fa-sign-in-alt" aria-hidden="true"></i>
            </button>

            <span *ngIf="isSending && sendingId === account.id">
              <i class="fas fa-spinner fa-spin fa-lg icons"> </i>
            </span>
            <button class="bg-transparent border-0 p-0 ms-2"
                    aria-label="Edit User"
                    ngbTooltip="Edit User"
                    triggers="hover"
                    tooltipClass="tooltip-border-right-arrow-right"
                    placement="left"
                    (click)="editUser(account)">
              <i class="fas fa-lg fa-pencil-square" aria-hidden="true"></i>
            </button>

            <button class="bg-transparent border-0 p-0 ms-2"
                    aria-label="Edit User Licenses"
                    ngbTooltip="Edit User Licenses"
                    triggers="hover"
                    tooltipClass="tooltip-border-right-arrow-right"
                    placement="left"
                    (click)="editUserLicenses(account.id, account.firstName)">
              <i class="fas fa-lg fa-address-card" aria-hidden="true"></i>
            </button>

            <button class="bg-transparent border-0 p-0 ms-2"
                    aria-label="Delete User"
                    ngbTooltip="Delete User"
                    triggers="hover"
                    tooltipClass="tooltip-border-right-arrow-right"
                    placement="left"
                    (click)="deleteUser(account.id)">
              <i class="fas fa-lg fa-trash" aria-hidden="true"></i>
            </button>

            <button class="bg-transparent border-0 p-0 ms-2"
                    aria-label="Update Email"
                    ngbTooltip="Update Email"
                    triggers="hover"
                    tooltipClass="tooltip-border-right-arrow-right"
                    placement="left"
                    (click)="editEmailModal(account.id, account.email)">
              <i class="fas fa-lg fa-at" aria-hidden="true"></i>
            </button>
        </div>
        </td>
      </tr>
      </tbody>
    </ccc-table>
    <div *ngIf="!isLoading && accounts?.length === 0"
         class="no-accounts">
      <h3 class="modal-title">
        No accounts found
      </h3>
    </div>
  </div>

  <ccc-confirm-modal #modalDeleteAccount
                     confirmMessage="Are you sure you want to delete the account?"
                     confirmTitle="Delete account"
                     (confirmAction)="onConfirmDelete($event)">
  </ccc-confirm-modal>

  <ccc-cca-user-modal #userModal
                      *ngIf="addAccount"
                      [orgName]="orgName"
                      [orgId]="orgId"
                      (newAccount)="onNewAccount($event)"
                      (editAccount)="onEditAccount($event)">
  </ccc-cca-user-modal>

  <ccc-confirm-modal #modalSave
                     confirmTitle="Warning"
                     [confirmMessage]="confirmMessage">
  </ccc-confirm-modal>

  <ccc-cca-user-license-modal #licensesModal></ccc-cca-user-license-modal>
  <app-email-modal #editEmail (updateEmail)="onUpdateEmail($event)"></app-email-modal>
</div>
